<template>
    <div class="signature">
        <m-pane
            ref="tablePage"
            class="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            pageID="financeInfo"
            :currentPage="currentPage"
            @start-btn="handleStart"
            @stop-btn="handleStop"
            @synchronize-btn="handleSynchronize('button')"
            @authorize-btn="handleAuthorize"
            @row-db-click="rowDBclick"
            @selectChange="selectChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
        </m-pane>
        <syncTipsDialog ref="syncTipsDialog" @auth="handleAuthorize"/>
    </div>
</template>
<script>
// import { identityVerify, phoneVerify } from '../../../../../constant/formRegular.js';
// import upload from '../../../../../components/upload/Index';
// import preview from '../../../../../components/AttachmentDialog';
// import changeDialog from './ChangeDialog';
import mPane from '../../../../../components/Table/Index.vue';
import syncTipsDialog from '../../../manage/keyData/tabs/signature/syncTipsDialog.vue'
import config from './config.js';
import { getDataList, startStamperInfo, stopStamperInfo, getAuthorizationUrl, synStamperInfo } from '../../../../../api/signature.js';
export default {
    name: 'Signature',
    components: { mPane, syncTipsDialog },
    props: {
        supplierTab: {
            type: Object,
            default() {
                return {
                    supplierCode: ''
                };
            }
        }
    },
    data() {
        return {
            totalData: [],
            config,
            pageTotal: 0,
            loading: false,
            currentPage: 1,
            selected: [],
            searchParams: {
                pageSize: 10,
                pageNo: 1
            },
            supplierTab_: {}
        };
    },
    methods: {
        /** 点击查询 调接口，拿table数据 **/
        handleSearch() {
            const params = { supplierCode: this.supplierTab_.supplierCode, ...this.searchParams };

            getDataList(params).then((res) => {
                if (res && res.code === '0') {
                    this.totalData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        /** 启用 **/
        handleStart() {
            if (this.selected.length === 0) {
                this.$message.warning('当前没有选中的数据');
            } else if (this.selected.length > 1) {
                this.$message.warning('当前只能操作一条数据！');
            } else {
                this.$confirm('是否确认启用？', '启用确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    const params = {
                        supplierCode: this.selected[0].supplierCode,
                        stamperCode: this.selected[0].stamperCode,
                        stamperIdcard: this.selected[0].stamperIdcard,
                        stamperMobile: this.selected[0].stamperMobile,
                        stamperEmail: this.selected[0].stamperEmail
                    };
                    startStamperInfo(params).then(res => {
                        if (res && res.code === '0') {
                            this.$message.success('已启用');
                            this.handleSearch();
                        }
                    });
                });
            }
        },
        /** 停用 **/
        handleStop() {
            if (this.selected.length === 0) {
                this.$message.warning('当前没有选中的数据');
            } else if (this.selected.length > 1) {
                this.$message.warning('当前只能操作一条数据！');
            } else {
                this.$confirm('是否确认停用？', '停用确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    const params = {
                        supplierCode: this.selected[0].supplierCode,
                        stamperCode: this.selected[0].stamperCode,
                        stamperIdcard: this.selected[0].stamperIdcard,
                        stamperMobile: this.selected[0].stamperMobile,
                        stamperEmail: this.selected[0].stamperEmail
                    };
                    stopStamperInfo(params).then(res => {
                        if (res && res.code === '0') {
                            this.$message.success('已停用');
                            this.handleSearch();
                        }
                    });
                });
            }
        },
        /** 同步 **/
        handleSynchronize(type) {
            const params = {
                supplierCode: this.supplierTab_.supplierCode,
                tenantCode: ''
            };
            synStamperInfo(params).then(res => {
                if (res && res.code === '0') {
                    if(res.data && res.data.list && res.data.list.length){
                        this.totalData = res.data.list;
                        this.pageTotal = res.data.totalCount;
                        if(type === 'button') this.$message.success('同步信息成功');
                    }else{
                        //主体性质=法人，点击同步按钮触发的接口为空才需要弹窗
                        if(this.supplierTab_.propertyNature === '1' && type === 'button'){
                            this.$refs['syncTipsDialog'].init()
                        }
                        this.totalData = []
                        this.pageTotal = 0
                    }
                }
            });
        },
        /** 前往授权 **/
        handleAuthorize() {
            getAuthorizationUrl().then(res => {
                if (res && res.code === '0') {
                    window.open(res.data);
                }
            });
        },
        rowDBclick(row) {},
        selectChange(data) {
            this.selected = [].concat(data);
        },
        pageChange(data) {
            this.searchParams.pageNo = data;
            this.handleSearch();
        },
        sizeChange(data) {
            this.$set(this.searchParams, 'pageSize', data);
            this.$set(this.searchParams, 'pageNo', 1);
            this.handleSearch();
        }
    },
    mounted() {
    },
    watch: {
        supplierTab: {
            handler(nVal) {
                if (Object.keys(nVal).length) {
                    this.supplierTab_ = JSON.parse(JSON.stringify(nVal));
                    this.handleSearch();
                }
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="less">
.signature {
}
</style>